import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

const TYPES = {
  DOTS: 'dots',
  GHOST: 'ghost',
};

const listItemTypes = ({ type }) => {
  const types = {
    [TYPES.DOTS]: 'list-inside',
    [TYPES.GHOST]: 'list-none',
  };

  return types[type];
};

const ListItem = ({ children, className, type = TYPES.DOTS, ...rest }) => (
  <Text as="li" className={twMerge(listItemTypes(type), className)} {...rest}>
    {children}
  </Text>
);

ListItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node.isRequired,
  /**
   * Controls the list-style of component, being used only when this component
   * isn't wrapped by a `ListGroup`
   */
  type: PropTypes.oneOf(Object.values(TYPES)),
};

export default ListItem;
